var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_vm._v("首页 > 个人中心 > "),_c('span',{staticClass:"click",on:{"click":function($event){return _vm.$go(_vm.$route.meta.backUrl)}}},[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" > 详情")])}
var staticRenderFns = []

export { render, staticRenderFns }